import Vue from "vue";
import Router from "vue-router";
import * as RouteNames from "./routeNames";
import Home from "../views/Home.vue";
import Clients from "../views/Clients.vue";
import Users from "../views/Users.vue";
import AccessDenied from "../views/AccessDenied.vue";
import auth from "../services/auth";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: RouteNames.Home,
      component: Home
    },
    {
      path: "/accessDenied",
      name: RouteNames.AccessDenied,
      component: AccessDenied,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: "/users",
      name: RouteNames.Users,
      component: Users
    },
    {
      path: "/clients",
      name: RouteNames.Clients,
      component: Clients
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (auth.isAuthenticated() && (await auth.isAuthorized())) {
    //User is authenticated and authorized
    if (to.name === RouteNames.AccessDenied) {
      // Don't send an authenticated and authorized user to AccessDenied page, that would be weird.
      next({name: RouteNames.Home});
      return;
    }
  }
  else {
    //User is not authenticated or not authorized
    if (!to.meta || to.meta.allowAnonymous !== true) {
      //Unless this route allows anonymous, this person is not allowed to see it
      next ({name: RouteNames.AccessDenied});
      return;
    }
  }

  //We didn't hit a re-route case, so just route to desired route.
  next();
});

export default router;
